import { render, staticRenderFns } from "./VrstaTemeBase.vue?vue&type=template&id=ee831fb6&scoped=true&"
import script from "./VrstaTemeBase.vue?vue&type=script&lang=js&"
export * from "./VrstaTemeBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee831fb6",
  null
  
)

export default component.exports